import { render, staticRenderFns } from "./ProductConfigComponent.vue?vue&type=template&id=5af22da8&scoped=true"
import script from "./ProductConfigComponent.vue?vue&type=script&lang=js"
export * from "./ProductConfigComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductConfigComponent.vue?vue&type=style&index=0&id=5af22da8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af22da8",
  null
  
)

export default component.exports